import { render } from "./DistributionDataCharts.vue?vue&type=template&id=2b075c40&scoped=true"
import script from "./DistributionDataCharts.vue?vue&type=script&lang=js"
export * from "./DistributionDataCharts.vue?vue&type=script&lang=js"

import "./DistributionDataCharts.vue?vue&type=style&index=0&id=2b075c40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b075c40"]])

export default __exports__